export const config = {
  apiKey: "AIzaSyDcZ8zLyP2LNgFuunKSh1JMHlHWSIvi9g8",
  authDomain: "app-3d-tool.firebaseapp.com",
  projectId: "app-3d-tool",
  storageBucket: "app-3d-tool.appspot.com",
  messagingSenderId: "918038612663",
  appId: "1:918038612663:web:1580eb230d8b3f6dc25b32",
  measurementId: "G-9R03QPE369",
};
